import { CurrencyDisplay, CustomTable, ModalError } from "components";
import { getErrors } from "utils";
import axios from "axios";
import { getTotalPage } from "lib";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@material-ui/icons";

const ModalBalanceMutationDetail = ({
  open,
  onClose,
  dataTable,
  totalPage,
  queryParams,
  getDataTableDetail,
}) => {
  const [loadingPage, setLoadingPage] = useState(false);

  const columnTableSong = [
    {
      name: "song_title",
      title: "Song",
    },
    {
      name: "all",
      title: "Value",
      renderText: item => (
        <CurrencyDisplay value={item.value} decimalScale={2} prefix="Rp" />
      ),
    },
  ];

  return (
    <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={onClose}>
      <DialogTitle>
        <Typography fontSize={24} fontWeight={700}>
          Revenue Information
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={theme => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <Box mt="24px">
          <CustomTable
            columnTable={columnTableSong}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={totalPage}
            handleChangePage={(_, page) =>
              getDataTableDetail(queryParams?.id, page, "page")
            }
            handleChangePageSize={e =>
              getDataTableDetail(queryParams?.id, e?.target?.value, "size")
            }
            isLoading={loadingPage}
            maxHeight={400}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalBalanceMutationDetail;
